import React from 'react';
import styled from 'styled-components';
import { breakpoints, Container } from '../../styles/layout';
import { typeT21sb, typeT38sb } from '../../styles/typography/presets';
import TextCombo from '../shared/TextCombo';


const ValueItem = styled.li`
  padding-left: 27px;
`;

const ValuesItems = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
`;

const Title = styled.div`
  ${typeT21sb};
`;

const CustomContainer = styled(Container)`
  padding: 60px 0;
  ${Title} {
    grid-column: 2 / span 8;
    margin-bottom: 30px;
  }
  ${ValuesItems} {
    grid-column: 2 / span 8;
    
    ${ValueItem} {
      margin-bottom: 42px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  
  @media(min-width: ${breakpoints.lg}) {
    padding: 120px 0;
    ${Title} {
      ${typeT38sb};
      grid-column: 2 / span 8;
      margin-bottom: 87px;
    }
    ${ValuesItems} {
      grid-column: 2 / span 8;
      
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-column-gap: 75px;
      grid-row-gap: 87px;
      
      ${ValueItem} {
        margin-bottom: 0;
      }
      
      ${ValueItem}:nth-child(4n+1) {
        grid-column: 1 / span 1;
      }
      ${ValueItem}:nth-child(4n+2) {
        grid-column: 2 / span 1;
      }
      ${ValueItem}:nth-child(4n+3) {
        grid-column: 2 / span 1;
      }
      ${ValueItem}:nth-child(4n+4) {
        grid-column: 3 / span 1;
      }
    }
  }
`;

const ValuesSection = ({pageData}) => (
  <CustomContainer id={'values'}>
    <Title>Our Culture & Values</Title>
    <ValuesItems>
      {pageData.values_items.map((value, index) => (
        <ValueItem key={index}>
          <TextCombo
            title={(index + 1).toString().padStart(2, '0')}
            message={value.title}
            briefHtml={value.brief.html}
          />
        </ValueItem>
      ))}
    </ValuesItems>

  </CustomContainer>
);

export default ValuesSection;